<template>
  <div class="profilePreview">
    <div class="prespace"></div>
    <div class="content">
      <div class="meta">
        <div class="authorImageLink">
          <ProfileImage
            :height="700"
            :width="700"
            :imageHeight="40"
            :imageWidth="40"
            :marginRight="0"
            :profileImageUrl="partner.metadata.profileImageUrl"
          />
        </div>
        <div class="name">{{ partner.metadata.displayName }}</div>
        <div class="profileMeta" v-if="profile && ready">
          <div class="joinDate">Joined: {{ getJoinDate }}</div>
          <div class="sessionCount">{{ sessionCountText }}</div>
        </div>
        <!-- <a
          :href="`/profile/${partner.metadata.ID}`"
          class="visitProfile"
          >Visit profile</a
        > -->
        <a :href="`/profile/${partner.metadata.ID}`" class="visitProfile"><div>Visit profile</div></a>
        <div class="submeta" v-if="profile && ready">
          <div class="metagroup" v-if="profile.bio">
            <div class="metatitle">Bio</div>
            <div class="bioText" v-html="profile.bio"></div>
          </div>
          <!-- <div class="metagroup">
            <div class="metatitle">Preferences</div>
          </div>
          <div class="metagroup">
            <div class="metatitle">Languages</div>
          </div> -->
        </div>
        <div class="submeta">
          <div v-for="(preference, i) in partner.preferences" :key=i>
            {{preference.name}}: {{getPreference(preference.name, preference.preference)}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { getProfilePreview } from "../../CalendarRequests";
import ProfileImage from "../../../../components/ProfileImage";
import { preferenceMapper } from "@/utilities/utilities";
/**
 *
 * @TODO
 * - indicator for what each preference means
 * - bio
 * - starred/not?
 * - gamification indicators
 * - shared history (last session together, etc.)
 * - session count
 * - join date
 * - location (country, city)
 * - timezone
 * - languages
 * - gender
 * - (interests?)
 */

export default {
  name: "ProfilePreview",
  props: {
    partner: Object,
    preferences: Object,
  },
  components: {
    ProfileImage,
  },
  async created() {
    await this.getProfilePreview();
  },
  data() {
    return {
      ready: false,
      profile: null,
    };
  },
  computed: {
    sessionCountText() {
      const count = this.profile.sessionCount;

      let sessionText = count === 1 ? "session" : "sessions";
      return `${count} ${sessionText}`;
    },
    getJoinDate() {
      const date = new Date(this.profile.createdAt);
      return format(new Date(date), `MMM d, y`);
    },
  },
  methods: {
    async getProfilePreview() {
      let userID = this.partner.metadata.ID;
      const profile = await getProfilePreview(userID);
      if (profile && profile.previewData) {
        this.profile = profile.previewData;
      }
      this.ready = true;
    },
    getPreference(prefName, prefValue) {
      console.log("args: ", prefName, prefValue);
      console.log("res: ", preferenceMapper(prefName)[prefValue]);
      return preferenceMapper(prefName)[prefValue];
    }
  },
};
</script>

<style scoped>
.profilePreview {
  display: flex;
  position: absolute;
  top: 17px;
  right: -25px;
  z-index: 1000;
  width: 252px;
  flex-direction: column;
  cursor: default;
}

.profilePreview .content {
  width: 250px;
  /* height: 2px; */
  border: 1px solid #efefef;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  z-index: 1000;
  transition: 0.2s ease-in-out;
  background-color: white;
  box-shadow: 0px 1px 3px 0px #efefef;
  position: relative;
}

.profilePreview .prespace {
  margin-bottom: -15px;
  height: 22px;
  width: 100%;
}

.profilePreview .meta {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 12px 15px;
  padding-top: 18px;
}

.profilePreview .name {
  margin-top: 10px;
  font-size: 19px;
  font-weight: 600;
  color: #2d2d2d;
}

.profilePreview .viewProfile {
  font-size: 14px;
  background-color: #fbfbfb;
  border: 1px solid #ebebeb;
  padding: 4px 12px;
  margin-top: 10px;
}

.profilePreview .visitProfile {
  border-radius: 360px;
  padding: 2px 8px;
  font-weight: 700;
  box-sizing: border-box;
  background-color: #ffffff;
  color: #2d2d2d;
  display: flex;
  /* align-items: center;
  justify-content: center; */
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  z-index: 9999;
  border: 1px solid #e6e6e6;
  margin: 0 auto;
  margin-top: 8px;
  /* position: absolute; */
  /* right: 8px; */
  /* top: 8px; */
}

.profilePreview .submeta {
  width: 100%;
  margin-top: 10px;
}

.profilePreview .metagroup {
  padding-top: 10px;
  padding-bottom: 6px;
  padding-left: 2px;
}

.profilePreview .metatitle {
  text-align: left;
  font-weight: 600;
}

.profilePreview .joinDate {
  font-size: 13px;
  text-align: center;
  margin: 0 auto;
  font-weight: 600;
  color: #2d2d2d;
}

.profilePreview .sessionCount {
  text-align: center;
  font-size: 14px;
  border-radius: 360px;
  background-color: #2d2d2d;
  margin: 0 auto;
  color: white;
  justify-content: center;
  display: flex;
  align-items: center;
  padding: 2px 0px;
  margin-top: 6px;
  font-weight: 700;
  max-width: 112px;
}

.profilePreview .bioText {
  text-align: left;
  font-size: 14px;
}
</style>